
import { NoseurObject, Subscriber } from "@rivtn/noseur";
import { NotificationGroup, Notifier } from "../../components/shared/Notifiier";
import { ApiResponseData, BaseService, INotification, SanitizedResponse } from "../BaseService";

export class MemberNotificationService extends BaseService {

    protected static instance: MemberNotificationService;

    private constructor() {
        super();
    }

    static getInstance() {
        if (!MemberNotificationService.instance) MemberNotificationService.instance = new MemberNotificationService();
        return MemberNotificationService.instance;
    }

    queryNotifications(params: NoseurObject<string | number | undefined> = { page: 1, size: 10 }): Promise<SanitizedResponse<ApiResponseData<INotification> & { grouped_notifications: NotificationGroup }>> {
        return this.report(this.transport.get("/v1/member/notification", { query: this.normalizeParams(params) }), ({ sanitized }: SanitizedResponse<ApiResponseData<INotification> & { grouped_notifications: NotificationGroup }>) => {
            sanitized.grouped_notifications = Notifier.groupNotifications(sanitized.content!);
        });
    }

    markAllAsRead(): Promise<SanitizedResponse<void>> {
        return this.report(this.transport.put("/v1/member/notification/read_all", {}));
    }

    updateNotificationStatus(id: string, status = "READ"): Promise<SanitizedResponse<void>> {
        return this.report(this.transport.patch(`/v1/member/notification/${id}`, { status }), (_: any) => {
            Subscriber.report("OMNEHOST.NOTIFICATION.READ");
        });
    }

}
